module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#sort",
      toString: function () {
        return this.url;
      }
    }